import React from 'react';

import { observer } from 'mobx-react-lite';

import { LoadingContainer } from '../containers';

import { FactoryRouter } from './factoryRouter';

export const Factory = observer(({ components }) => {
  return (
    <LoadingContainer>
      <FactoryRouter components={components} />
    </LoadingContainer>
  );
});
